const getDefaultTruckState = () => {
  return {
    allTrucks: [],
    selectedTruck: {},
  }
}

export default getDefaultTruckState()
export { getDefaultTruckState }
